import { pagesInfo } from "./pagesInfo";
import { storageSeccionesAnalytics } from "./sessionData";

/** Si el perfil del usuario tiene la sección de Analytics (Key de la tabla Secciones). */
export const tieneAcceso = (seccionKey) => storageSeccionesAnalytics().includes(seccionKey);

/** Primera página a la que el usuario tiene acceso, o null si no tiene ninguna. */
export const paginaInicial = () => {
  const pagina = pagesInfo.find((page) => tieneAcceso(page.seccionKey));
  return pagina ? pagina.uri : null;
};
